import { MdConnectWithoutContact } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';

import { Logo } from '../Logo';
import { MenuDropdown } from '../MenuDropdown';

export function Navbar() {
  const location = useLocation();
  const isExamRoute = location.pathname.startsWith('/exam');

  return (
    <nav className={`${isExamRoute ? 'px-3 py-2' : 'p-4'} bg-gray-900`}>
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/login" key="certifications">
          <div className="flex items-center min-w-0">
            <Logo />
            <p
              className={`ml-2 hidden text-xl font-bold text-white sm:block ${
                isExamRoute ? 'max-w-[270px] truncate' : ''
              }`}
            >
              Assban Exames de Certificação
            </p>
            <p className="ml-2 text-lg font-bold text-white sm:hidden">
              Assban
            </p>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          <Link to="/faq" key="faq">
            <button
              className="text-white hover:opacity-75 flex items-center"
              type="button"
              data-testid="dropdown-button"
            >
              <MdConnectWithoutContact
                className={isExamRoute ? 'mr-0 sm:mr-2' : 'mr-2'}
                size={20}
                color="white"
              />
              <span className={isExamRoute ? 'hidden sm:inline' : ''}>
                Contato
              </span>
            </button>
          </Link>
          <MenuDropdown />
        </div>
      </div>
    </nav>
  );
}
